var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgImage28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6H6C4.89543 6 4 6.89543 4 8V15.5859L9.29297 10.2929C9.68349 9.90237 10.3167 9.90237 10.7072 10.2929L17.0001 16.5858L20.293 13.2929C20.6835 12.9024 21.3167 12.9024 21.7072 13.2929L24 15.5857V8C24 6.89543 23.1046 6 22 6ZM4 20V18.4143L10.0001 12.4142L16.293 18.7071C16.6835 19.0976 17.3167 19.0976 17.7072 18.7071L21.0001 15.4142L24 18.4141V20C24 21.1046 23.1046 22 22 22H6C4.89543 22 4 21.1046 4 20ZM6 4C3.79086 4 2 5.79086 2 8V20C2 22.2091 3.79086 24 6 24H22C24.2091 24 26 22.2091 26 20V8C26 5.79086 24.2091 4 22 4H6ZM16 10C16 9.44772 16.4477 9 17 9C17.5523 9 18 9.44772 18 10C18 10.5523 17.5523 11 17 11C16.4477 11 16 10.5523 16 10ZM17 7C15.3431 7 14 8.34315 14 10C14 11.6569 15.3431 13 17 13C18.6569 13 20 11.6569 20 10C20 8.34315 18.6569 7 17 7Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgImage28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;